import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule, LocationStrategy, HashLocationStrategy } from '@angular/common';
import { LayoutRoutingModule } from './layout.routing';
import { SlideshowModule } from 'ng-simple-slideshow';

import { LayoutComponent } from './layout.component';
import { MenuComponent } from './menu/menu.component';
import { CarouselComponent } from './carousel/carousel.component';
import { LoginComponent } from './login/login.component';
import { LoginService } from './service/login.service';
import { IndexComponent } from './index/index.component';

import { AuthorizationService } from './service/authorization.service'
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UserServiceProvider } from './service/user-service';
import { TranslateModule } from '@ngx-translate/core';
import { TranslateLoader } from '@ngx-translate/core';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
 

export function HttpLoaderFactory(http: HttpClient) {
    // return new TranslateHttpLoader(http, './assets/locales/', '.json');
}
// import { AngularFireModule, FirebaseAppConfigToken } from 'angularfire2';
// import { AngularFireDatabaseModule } from 'angularfire2/database';
// import { AngularFireAuthModule } from 'angularfire2/auth';

// export const firebaseConfig = {
//     apiKey: "AIzaSyB2H1KL8zWWp8guUO9kZiivy2v6rFDTvRQ",
//     authDomain: "myjnces.firebaseapp.com",
//     databaseURL: "https://myjnces.firebaseio.com",
//     storageBucket: "",
//     messagingSenderId: "590042538541"
//   };

@NgModule({
    imports: [
        BrowserModule, 
        LayoutRoutingModule,
        SlideshowModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        ToastrModule.forRoot(),
        CommonModule,
        BrowserAnimationsModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        // AngularFireModule.initializeApp(firebaseConfig),
        // AngularFireDatabaseModule,
        // AngularFireAuthModule

    ],
    declarations: [
        MenuComponent, 
        LayoutComponent,
        CarouselComponent,
        LoginComponent,
        IndexComponent
    ],
    providers: [
        LoginService,
        AuthorizationService,
        UserServiceProvider,
  
  { provide: LocationStrategy, useClass: HashLocationStrategy },
    ]
})

export class LayoutModule {}



// WEBPACK FOOTER //
// /home/xpro/Documentos/ances/myjangular/src/app/layout/layout.module.ts